module.exports = __webpack_public_path__ + "img/5_Reflect Niclas Wendlinger und Markus Nguyen.849b531d.jpg";